import { Database } from 'types/supabase'
import { supabaseClient } from 'supabase'
import { uploadImage } from 'supabase/files'

export type UpdateAdvertiserParams = {
  id: string
  name: Database['public']['Tables']['advertisers']['Row']['name']
  category: Database['public']['Tables']['advertisers']['Row']['category']
  contact_email: Database['public']['Tables']['advertisers']['Row']['contact_email']
  contact_phone?: Database['public']['Tables']['advertisers']['Row']['contact_phone']
  whatsapp?: Database['public']['Tables']['advertisers']['Row']['whatsapp']
  website?: Database['public']['Tables']['advertisers']['Row']['website']
  instagram?: Database['public']['Tables']['advertisers']['Row']['instagram']
  currLogoUrl?: string | null
  newLogoFile?: File
}

export const updateAdvertiser = async ({
  id,
  name,
  category,
  contact_email,
  contact_phone,
  whatsapp,
  website,
  instagram,
  currLogoUrl,
  newLogoFile,
}: UpdateAdvertiserParams) => {
  const updatedAdvertiser = {
    name,
    category,
    contact_email,
    contact_phone,
    whatsapp,
    website,
    instagram,
  }

  const { error, data } = await supabaseClient
    .from('advertisers')
    .update(updatedAdvertiser)
    .eq('id', id)
    .select()

  if (error) {
    throw error
  }

  let logoUrl = currLogoUrl

  if (newLogoFile) {
    logoUrl = await uploadImage(
      newLogoFile,
      `${Date.now()}.${newLogoFile.type.split('/')[1]}`,
      'advertisers',
      id
    )

    const { error: updateError } = await supabaseClient
      .from('advertisers')
      .update({ logo_url: logoUrl })
      .eq('id', id)

    if (updateError) {
      throw updateError
    }
  }

  return {
    id: data[0].id,
    name: data[0].name,
    logo_url: logoUrl
  }
}